export default __webpack_public_path__ + "static/media/no_image.01a9e40b.jpg";